module.exports = "# Assembly Start\n\n## Notes\n\n### Start\n\n&nbsp;\n\n# Know The Risks Icon\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/02_start/start.md
// module id = 1520
// module chunks = 2